// extracted by mini-css-extract-plugin
export default {"root":"disclaimerWidget_root__LsoEr","content":"disclaimerWidget_content__mc882","buttons":"disclaimerWidget_buttons__f1oLF","loading":"disclaimerWidget_loading__Z4zjK"};